import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { InformationPageService } from "src/app/services/informationPage.service";
import { TranslateService } from "@ngx-translate/core";
import { BrowserStorageService } from "src/app/services/storage.service";
import { InformationPageContent } from "src/app/intefaces/information-page-content.interface";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { HttpAlertService } from "src/app/services/http-alert.service";
import { Title } from "@angular/platform-browser";

@Component({
  selector: "app-contact",
  templateUrl: "./contact.component.html",
  encapsulation: ViewEncapsulation.None,
  styleUrls: ["./contact.component.scss"],
})
export class ContactComponent implements OnInit {
  public contactForm: FormGroup;
  contactHtml: InformationPageContent = { content: "" };
  loading = false;

  constructor(
    private pageService: InformationPageService,
    private translate: TranslateService,
    private httpAlertService: HttpAlertService,
    private browserStorageService: BrowserStorageService,
    private fb: FormBuilder,
    private title: Title
  ) {}

  ngOnInit(): void {
    this.initContent(null);
    this.translate.onLangChange.subscribe((lang) => {
      this.initContent(lang.lang);
    });

    this.contactForm = this.fb.group({
      name: ["", Validators.required],
      email: ["", [Validators.required, Validators.email]],
      text: ["", Validators.required],
    });

    this.title.setTitle(this.translate.instant("title_contact"));
  }

  private initContent(lang: string): void {
    if (lang == null) {
      lang = this.browserStorageService.get("_lang");
      if (lang == null || lang == "") {
        lang = "pl";
      }
    }
    this.pageService
      .getInformationPage(this.pageService.PAGES.CONTACT, lang)
      .subscribe((response: any) => {
        this.contactHtml.content =
          response.data.page[Object.keys(response.data.page)[0]];
      });
  }

  submitForm() {
    this.loading = true;
    this.pageService.contactform(this.contactForm.value).subscribe(
      (data) => {
        if (data.success) {
          this.httpAlertService.success(
            this.translate.instant("contact_success")
          );
          this.contactForm.reset();
        }
        this.loading = false;
      },
      (err) => {
        this.loading = false;
        this.httpAlertService.error(this.translate.instant(err.error.message));
      }
    );
  }
}
